import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { formatPackSize } from 'common/utils/formatDrugLabel';

/**
 * Pack-size and dosage-form line rendered underneath the drug name + strength in the work queues,
 * in smaller secondary text — e.g. "pack size: 1ML (vial)", or just "(vial)" when the item has a
 * form but no complete pack size.
 *
 * Renders nothing at all when there is neither, so callers can drop it into a cell
 * unconditionally — unless `noMappingMessage` is passed, in which case that text renders in its
 * place instead of an empty cell (the bulk queue uses this to flag rows with no resolved product).
 *
 * Shared by the bulk, prescription review and central fill queues so the three stay identical.
 */
const PackSizeText = ({ packSizeValue, packSizeUnit, formAlias, noMappingMessage }) => {
  const packSize = formatPackSize({ packSizeValue, packSizeUnit, formAlias });

  if (!packSize && !noMappingMessage) return null;

  return (
    <Typography
      variant='caption'
      color='textSecondary'
      // display:block puts it on its own line under the inline-flex drug row above; the tightened
      // line height keeps the two lines inside the existing row height.
      sx={{ display: 'block', lineHeight: 1.2 }}
    >
      {packSize || noMappingMessage}
    </Typography>
  );
};

PackSizeText.propTypes = {
  packSizeValue: PropTypes.string,
  packSizeUnit: PropTypes.string,
  formAlias: PropTypes.string,
  noMappingMessage: PropTypes.string,
};

PackSizeText.defaultProps = {
  packSizeValue: undefined,
  packSizeUnit: undefined,
  formAlias: undefined,
  noMappingMessage: undefined,
};

export default PackSizeText;
